module.exports = __webpack_public_path__ + "./img-judy_bf1ffd3772f94f15e82f9dc388c4f9a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/img-judy.png
// module id = 447
// module chunks = 0